import { Tooltip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { formatarNumero, formatarPercentual } from "./analiseUtils";

// Mesmo padrão visual da tabela dinâmica do Excel (PivotStyleDark3), igual à planilha exportada
const CORES = {
    cabecalho: "#843C0C",
    cliente: "#FCE4D6",
    pessoa: "#F8CBAD",
    texto: "#000000",
    textoCabecalho: "#FFFFFF",
};

const celulaBase = {
    display: "table-cell",
    py: 0.75,
    px: 1.5,
    fontSize: "0.8rem",
    whiteSpace: "nowrap",
    verticalAlign: "top",
    borderBottom: "1px solid #FFFFFF",
};

const celulaCabecalho = {
    ...celulaBase,
    backgroundColor: `${CORES.cabecalho} !important`,
    color: `${CORES.textoCabecalho} !important`,
    fontWeight: "bold",
};

/** % do tempo da pessoa por cliente, mês a mês (cada mês soma 100%). */
export default function TabelaPercentual({ bloco, meses, rotuloLinhas }) {
    const celulaCliente = { ...celulaBase, backgroundColor: `${CORES.cliente} !important`, color: `${CORES.texto} !important`, fontWeight: "bold" };
    const celulaPessoa = { ...celulaBase, backgroundColor: `${CORES.pessoa} !important`, color: `${CORES.texto} !important` };

    return (
        <TableContainer sx={{ boxShadow: "none", borderRadius: 0, overflowX: "auto", background: "transparent" }}>
            <Table size="small" sx={{ width: "100%", minWidth: "900px", borderCollapse: "collapse" }}>
                <TableHead sx={{ display: "table-header-group" }}>
                    <TableRow sx={{ display: "table-row" }}>
                        <TableCell sx={celulaCabecalho}>&nbsp;</TableCell>
                        <TableCell sx={celulaCabecalho} colSpan={meses.length} align="center">Mês</TableCell>
                        <TableCell sx={celulaCabecalho}>&nbsp;</TableCell>
                    </TableRow>
                    <TableRow sx={{ display: "table-row" }}>
                        <TableCell sx={celulaCabecalho}>{rotuloLinhas}</TableCell>
                        {meses.map(mes => (
                            <TableCell key={mes} align="right" sx={celulaCabecalho}>{mes}</TableCell>
                        ))}
                        <TableCell align="right" sx={celulaCabecalho}>Total Geral</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody sx={{ display: "table-row-group" }}>
                    {bloco.linhas.map(linha => [
                        <TableRow key={`${linha.cliente}-cliente`} sx={{ display: "table-row" }}>
                            <TableCell sx={celulaCliente} colSpan={meses.length + 2}>{linha.cliente}</TableCell>
                        </TableRow>,
                        <TableRow key={`${linha.cliente}-pessoa`} sx={{ display: "table-row" }}>
                            <TableCell sx={{ ...celulaPessoa, pl: 4 }}>{bloco.nome}</TableCell>
                            {linha.percentuais.map((percentual, idx) => (
                                <TableCell key={meses[idx]} align="right" sx={celulaPessoa}>
                                    {percentual !== null && percentual !== undefined ? (
                                        <Tooltip title={`${formatarNumero(linha.quantidades[idx])} de ${formatarNumero(bloco.totaisMes[idx])} fichas acionadas no mês`} placement="top">
                                            <span>{formatarPercentual(percentual)}</span>
                                        </Tooltip>
                                    ) : ""}
                                </TableCell>
                            ))}
                            <TableCell align="right" sx={celulaPessoa}>
                                <Tooltip title={`${formatarNumero(linha.quantidadeTotal)} de ${formatarNumero(bloco.totalGeral)} fichas acionadas no trimestre`} placement="top">
                                    <span>{formatarPercentual(linha.percentualTotal)}</span>
                                </Tooltip>
                            </TableCell>
                        </TableRow>,
                    ])}
                    <TableRow sx={{ display: "table-row" }}>
                        <TableCell sx={celulaCabecalho}>Total Geral</TableCell>
                        {bloco.totaisMes.map((total, idx) => (
                            <TableCell key={meses[idx]} align="right" sx={celulaCabecalho}>{total > 0 ? formatarPercentual(1) : ""}</TableCell>
                        ))}
                        <TableCell align="right" sx={celulaCabecalho}>{bloco.totalGeral > 0 ? formatarPercentual(1) : ""}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    );
}
